module.exports = __webpack_public_path__ + "img/logo_top.9771a0c0.png";